import type { APIOptions } from 'primereact/api';

/**
 * The `PrimeReactProvider` value every app mounts (Center-PWA and center-auth `main.tsx`)
 * and Storybook's preview renders under, so a story sees the same PrimeReact behaviour
 * as the app.
 *
 * `dropdown.select`: PrimeReact's Dropdown (10.9) renders a visually hidden `<select>`
 * that mirrors the selection for native form submission. It is unnamed and duplicates
 * the combobox input the user actually operates, so assistive technology meets an
 * unlabelled second control (axe `select-name`) on every Dropdown, the DataTable
 * paginator's rows-per-page included. The mirror is removed from the accessibility
 * tree; the combobox input (pt section `input`) keeps its name and focus.
 */
export const primeReactConfig: Partial<APIOptions> = {
  pt: {
    dropdown: {
      select: { 'aria-hidden': true },
    },
  },
};
